// Stories 11030/11031: the Disclosure Order Date and Disclosure Upload Date are calendar days, not instants. The API
// stores the day as written and returns it as "2026-10-02T00:00:00", with no time zone at all, so the day the user
// sees is the day that travels, whatever zone the browser is in and whatever Alberta's clocks do (from November
// 2026 browsers and Windows servers no longer agree on Alberta's winter offset; a day has no offset to disagree on).
const pad = (number) => String(number).padStart(2, '0');

// Already a calendar day, or a calendar day at midnight as the API sends it: the day is taken as written. Parsing it
// with Date would read "2026-10-02" as UTC midnight, which is the day before in Alberta.
const DAY_AS_WRITTEN = /^(\d{4}-\d{2}-\d{2})(T00:00(:00(\.0+)?)?)?$/;

/**
 * The calendar day a date picker holds (its own year, month and day, as the user sees them), written yyyy-MM-dd;
 * null when there is no date or it cannot be read.
 */
export const toCalendarDay = (date) => {
    if (date === null || date === undefined || date === '') return null;
    if (typeof date === 'string') {
        const asWritten = DAY_AS_WRITTEN.exec(date);
        if (asWritten) return asWritten[1];
    }
    const parsed = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(parsed.getTime())) return null;
    return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`;
};
